import { Control } from "../Control.js";

export class Label extends Control {

    constructor(parent, options = {}) {

        options = Object.assign({
            text: 'Label',
        }, options || {});

        super(parent, options);

        const {
            text = 'Label'
        } = options;

        this.text = text;

    };

    getText() {

        return (typeof this.text === 'function') ? this.text.call(this) : this.text;

    };

    getFor() {

        return (typeof this.for === 'function') ? this.for.call(this) : this.for;

    };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        let props = {
            id: this.getId(),
            for: this.getFor(),
            readonly: this.isReadOnly(),
            disabled: this.isDisabled(),
        },
            style = this.getCss();

        return renderer.el('label', style, props, [this.getText()]);

    };

}